import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "1120",
  height: "592",
  viewBox: "0 0 1120 592",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#clip0_1980_11111)\"><circle cx=\"1065\" cy=\"595\" r=\"224\" fill=\"url(#paint0_linear_1980_11111)\"></circle><circle cx=\"-23.9998\" cy=\"85\" r=\"224\" transform=\"rotate(70.9393 -23.9998 85)\" fill=\"url(#paint1_linear_1980_11111)\"></circle></g><defs><linearGradient id=\"paint0_linear_1980_11111\" x1=\"1065\" y1=\"371\" x2=\"882\" y2=\"570.5\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#EDEFF1\"></stop><stop offset=\"1\" stop-color=\"#EDEFF1\" stop-opacity=\"0\"></stop></linearGradient><linearGradient id=\"paint1_linear_1980_11111\" x1=\"303.646\" y1=\"-249.331\" x2=\"-87.1193\" y2=\"44.1476\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#EDEFF1\"></stop><stop offset=\"1\" stop-color=\"#EDEFF1\" stop-opacity=\"0\"></stop></linearGradient></defs>", 2)
  ])))
}
export default { render: render }